import { DistributorListType, FundManager, Trustee } from './api-types';

export const GET_FUNDS_LIST = 'GET_FUNDS_LIST';
export const GET_FUNDS_LIST_SUCCESS = 'GET_FUNDS_LIST_SUCCESS';

export const ADD_FUND = 'ADD_FUND';
export const ADD_FUND_SUCCESS = 'ADD_FUND_SUCCESS';

export const UPLOAD_BULK_FUND_SUCCESS = 'UPLOAD_BULK_FUND_SUCCESS';
export const UPLOAD_BULK_FUND = 'UPLOAD_BULK_FUND';

export const ADD_PLAN = 'ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';

export const GET_FUNDS_ACCESS = 'GET_FUNDS_ACCESS';
export const GET_FUNDS_ACCESS_SUCCESS = 'GET_FUNDS_ACCESS_SUCCESS';

export const UPDATE_FUND = 'UPDATE_FUND';
export const UPDATE_FUND_SUCCESS = 'UPDATE_FUND_SUCCESS';

export const GET_PLAN = 'GET_PLAN';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';

export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_PLAN_DETAILS_SUCCESS = 'GET_PLAN_DETAILS_SUCCESS';

export type addFundType = {
  bankAccountNumber: string;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
};

export type accessType = {
  fundSetupAccess: boolean;
};

export type topUpPlanType = {
  isTopupApplicable: boolean;
  topUpSetupFeeApplicable: string;
  topUpSetupFeeType: string | null;
  topUpMaxSetupFee: number | null;
  topUpMinSetupFee: number | null;
  topUpSetupFee: number | null;
  topUpMinCommitmentAmount: number | null;
  topUpMaxCommitmentAmount: number | null;
  topUpMinContributionPercentage: number | null;
  topUpAccreditedInvestorApplicable: string;
  topUpAccreditedMinCommitmentAmount: number | null;
  topUpManagementFeeApplicable: string;
  topUpManagementFeeType: string | null;
  topUpMinManagementFee: number | null;
  topUpMaxManagementFee: number | null;
  defaultTopUpManagementFee: number | null;
  topUpHurdleRateApplicable: string;
  topUpHurdleRateType: string | null;
  defaultTopUpHurdleRate: number | null;
  topUpMinHurdleRate: number | null;
  topUpMaxHurdleRate: number | null;
  topUpPerformanceFeeApplicable: string;
  topUpPerformanceFeeType: string | null;
  defaultTopUpPerformanceFee: number | null;
  topUpMinPerformanceFee: number | null;
  topUpMaxPerformanceFee: number | null;
  topUpExitChargeApplicable: string;
  topUpExitChargeType: string | null;
  defaultTopUpExitCharge: number | null;
  topUpMinExitCharge: number | null;
  topUpMaxExitCharge: number | null;
  topupExitChargeApplicableTill: string | null;
  topupMinInvestmentAmt: number | null;
  topUpPlacementFeeApplicable: string;
  topUpPlacementFeeType: string | null;
  topUpMaxPlacementFee: number | null;
  topUpMinPlacementFee: number | null;
  defaultTopUpPlacementFee: number | null;
  topUpOperatingExpenseApplicable: string;
  topUpOperatingExpenseType: string | null;
  topUpMaxOperatingExpense: number | null;
  topUpMinOperatingExpense: number | null;
  defaultTopUpOperatingExpenses: number | null;
};

export type addPlanType = topUpPlanType & {
  schemeId: number | string | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minInvestmentAmt: number | null;
  minContributionPercentage: number | null;
  defaultManagementFee: number | null;
  tcLink: string;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmount: number | null;
  managementFeeApplicable: string;
  managementFeeType: string | null;
  minManagementFee: number | null;
  maxManagementFee: number | null;
  hurdleRateApplicable: string;
  hurdleRateType: string | null;
  defaultHurdleRate: number | null;
  minHurdleRate: number | null;
  maxHurdleRate: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  defaultPerformanceFee: number | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  exitChargeApplicable: string;
  exitChargeType: string | null;
  defaultExitCharge: number | null;
  minExitCharge: number | null;
  maxExitCharge: number | null;
  managementFee?: number;
  exitChargeApplicableTill: string | null;
  parentShareClass: string;
};

export type addFundPlanType = addFundType &
  addPlanType & {
    id: string;
  };

export type DistributorDetailsInPlans = {
  distributorIds: string[] | number[];
  distributors: DistributorListType[];
};
export type ClassPlanProps = addPlanType & {
  id: string;
  fundManager: FundManager;
  trustee: Trustee;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  distributorDetails: DistributorDetailsInPlans;
};

export type FundProps = addFundType & {
  amcId: number;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  plans: ClassPlanProps[];
  id: string;
  [key: string]: string | number | boolean | ClassPlanProps[] | undefined | null;
};

export type GetFundsListResponseBody = {
  funds: FundProps[];
};

export const GET_FUNDS_SUCCESS = 'GET_FUNDS_SUCCESS';
export const GET_FUNDS = 'GET_FUNDS';

export const GET_DIRECTAPPLICABLEFUNDS_SUCCESS = 'GET_DIRECTAPPLICABLEFUNDS_SUCCESS';
export const GET_DIRECTAPPLICABLEFUNDS = 'GET_DIRECTAPPLICABLEFUNDS';

export const EXPORT_FUNDS_SUCCESS = 'EXPORT_FUNDS_SUCCESS';
export const EXPORT_FUNDS = 'EXPORT_FUNDS';
